class PenalidadesDadosGeraisUrlBuilder {
	constructor(tipo) {
		this.PATH = tipo.path
	}

	getUrlBuscarItensPenalidade(idEntidade) {
		return `api/${this.PATH}/penalidades/${idEntidade}/item`
	}
	getUrlAdicionarItensPenalidade() {
		return `api/${this.PATH}/penalidades/itens`
	}
}

export default PenalidadesDadosGeraisUrlBuilder
